"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatorPathGuard = calculatorPathGuard;
const navigation_1 = require("next/navigation");
function calculatorPathGuard({ calculator, prefixed, group }) {
    const expectsPrefix = "election" in calculator;
    const expectsGroup = "calculatorGroup" in calculator;
    if (prefixed !== expectsPrefix || Boolean(group) !== expectsGroup) {
        (0, navigation_1.notFound)();
    }
}
